module.exports = __webpack_public_path__ + "img/browse-vehicles-background-cjdr.eff3bc84.jpg";